import store from '../vuex'

import bus from '@utils/bus'
import {get} from '@utils/storage'

import swal from 'sweetalert2'

// Check if route needs auth
const needAuth = (route) => route.meta.auth !== false

// Check route API permission
const hasPermission = (route) => {
  const permissionName = route.meta.permission || route.name
  return store.getters.permissions.some((item) => {
    return item.name === permissionName
  })
}

export default async (to, from, next) => {
  // Position the scroll on top
  window.scrollTo(0, 0)

  // Show global loader
  bus.$emit('show-loader')

  // Await 300 ms to continue with router
  setTimeout(async () => {
    // Check if route doesn't need auth
    if (!needAuth(to)) {
      return next()
    }

    // Get auth data from storage
    const token = await get('token')
    const user = await get('user')
    const permissions = await get('permissions')
    const roles = await get('roles')

    // If token doesn't exists, redirect to auth page
    if (!token) {
      return next({ name: 'auth' })
    }

    // If exists, store in vuex the auth data
    const login = { token, user, permissions, roles }
    // Store login info in vuex to keep user logged
    await store.dispatch('login', login)

    // Verify permisisons
    if (!hasPermission(to)) {
      swal({
        title: 'Atenção',
        html: 'Acesso negado a esse recurso',
        type: 'warning'
      })
      console.log('Acesso negado', to.name)
      return next(false)
    }

    // Continue route
    return next()
  }, 300)
}



// WEBPACK FOOTER //
// ./src/router/beforeEach.js